import React from 'react'
import Icon from './Icon'

const EmptyS = ({text}) => {
  return (
    <>
      <Icon iconName='Empty Icon'/>
      <p className='text-gray-100 text-12 leading-5 mt-3.6'>{text}</p>
    </>
  )
}

export default EmptyS
